import { useState } from 'react';
import { Bars3Icon } from "@heroicons/react/24/outline";
import ConfirmDialog from '../../../components/dialogbox/ConfirmDialog';
import EmployeeAdd from '../components/employee/EmployeeAdd';

const Employee = ({ setIsMobileOpen }) => {

  const [dialog, setDialog] = useState({
    open: false,
    type: "info",
    title: "",
    message: "",
    confirmText: "",
    action: () => { },
  });

  return (
    <>
      <ConfirmDialog
        isOpen={dialog.open}
        onClose={() => setDialog((d) => ({ ...d, open: false }))}
        onConfirm={dialog.action}
        title={dialog.title}
        message={dialog.message}
        confirmText={dialog.confirmText}
        type={dialog.type}
      />
      <div className="w-full">
        {/* Heading */}
        <div className="w-full mb-5 flex flex-wrap items-center justify-between gap-2 sm:gap-4">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <button
              className="md:hidden p-2 bg-white shadow rounded-lg"
              onClick={() => setIsMobileOpen(true)}
            >
              <Bars3Icon className="h-5 w-5 sm:h-6 sm:w-6 text-gray-800" />
            </button>
            <div className="flex flex-wrap items-center">
              <h1 className="text-2xl sm:text-3xl font-extrabold tracking-wide text-blue-600">
                Empl
              </h1>
              <span className="text-2xl sm:text-3xl font-extrabold tracking-wide text-gray-800">
                oyee
              </span>
            </div>
          </div>
        </div>

        <hr className="border-t border-gray-200 my-4" />

        {/* Data Creation Code */}
        <div className='w-full'>
          <EmployeeAdd open={true} />
        </div>
      </div>
    </>
  )
}

export default Employee;